import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  message,
  Space,
  Upload,
  Button,
  UploadProps,
  Image,
  Divider,
  Checkbox,
  Spin,
} from "antd";
import {
  createTable,
  getTable,
  getTableAll,
} from "../../api/Api";
import { initProvince, Province } from "../../models/Province";
import { County, initCounty } from "../../models/County";
import { City, initCity } from "../../models/City";
import { Hospital } from "../../models/Hospital";
import { apiUrl, loginInfo } from "../../config";
import { HospitalLogo } from "../../models/HospitalLogo";
import { useHistory } from "react-router-dom";

interface PropsType {
  visible: boolean;
  add: Function;
  addLogo:Function;
  setInvisible: Function;
}
export const AddHospital: React.FC<PropsType> = ({
  visible,
  add,
  addLogo,
  setInvisible,
}) => {
  const [provinceOptions, setProvinceOptions] = useState<any[]>([]);
  const [cityOptions, setCityOptions] = useState<any[]>([]);
  const [countyOptions, setCountyOptions] = useState<any[]>([]);
  const [province, setProvince] = useState<Province>(initProvince);
  const [city, setCity] = useState<City>(initCity);
  const [county, setCounty] = useState<County>(initCounty);
  //const [logoFileName, setLogoFileName] = useState("");
  const [logoContent, setLogoContent] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  useEffect(() => {
    buildProvinceOptions();
    form.setFieldsValue({
      reportHasCheckDoctor: false,
      reportPrintHospitalName: true,
      reportPrintHospitalLogo: false,
      province: '',
      city: '',
      county: '',
      reportTitle: '患龋风险评估报告',
      name: "",
    });
  }, [visible]);

  const buildProvinceOptions = async () => {
    const items: any[] = [];
    const data = await getTableAll("province");
    if(typeof data === "undefined"){
      history.push("/");      
    }
    data.forEach((a) => {
      items.push(
        <Select.Option key={a.id} value={a.id}>
          {a.name}
        </Select.Option>
      );
    });
    setProvinceOptions(items);
  };

  const buildCityOptions = async (provinceId: number) => {
    const items: any[] = [];
    const data = await getTableAll("city");
    if(typeof data === "undefined"){
      history.push("/");      
    }
    data.forEach((a) => {
      if (a.provinceId === provinceId) {
        items.push(
          <Select.Option key={a.id} value={a.id}>
            {a.name}
          </Select.Option>
        );
      }
    });
    setCityOptions(items);
  };
  const buildCountyOptions = async (cityId: number) => {
    const items: any[] = [];
    const data = await getTableAll("county");
    if(typeof data === "undefined"){
      history.push("/");      
    }
    data.forEach((a) => {
      if (a.cityId === cityId) {
        items.push(
          <Select.Option key={a.id} value={a.id}>
            {a.name}
          </Select.Option>
        );
      }
    });
    setCountyOptions(items);
  };
  const onProvinceChange = async (value) => {
    setProvince(await getTable("province", value));
    await buildCityOptions(value);
    setCity(initCity);
    setCounty(initCounty);
  };
  const onCityChange = async (value) => {
    setCity(await getTable("city", value));
    await buildCountyOptions(value);
    setCounty(initCounty);
  };
  const onCountyChange = async (value) => {
    setCounty(await getTable("county", value));
  };

  const handlerOk = async () => {
    const name: any = form.getFieldValue("name");
    if (typeof name === "undefined" || name.length === 0) {
      message.warning("医院名称不能为空!");
      return;
    }
    setLoading(true);
    let hospital: Hospital = {
      id: -1,
      key: -1,
      hospitalName: form.getFieldValue("name"),
      hospitalLogoFile: "",
      reportTitle: form.getFieldValue("reportTitle"),
      reportHasCheckDoctor: form.getFieldValue("reportHasCheckDoctor"),
      reportPrintHospitalName: form.getFieldValue("reportPrintHospitalName"),
      reportPrintHospitalLogo: form.getFieldValue("reportPrintHospitalLogo"),
      reportHospitalLogoAlign: "center",
      provinceId: province.id,
      cityId: city.id,
      countyId: county.id,
      provinceName: province.name,
      cityName: city.name,
      countyName: county.name,
    };
  
    hospital = await createTable("hospital", hospital);
    add(hospital);
    let hospitalLogo : HospitalLogo = {
      id:-1,
      hospitalId:hospital.id,
      key:hospital.id,
      content:logoContent,
    }
    addLogo(await createTable("hospitallogo",hospitalLogo));
    setLoading(false);
    setInvisible();
  };
  const handlerCancel = () => {
    setInvisible();
  };

  const props: UploadProps = {
    onRemove: (file) => { },
    beforeUpload: (file) => {
      let fileType = "";
      if (file.type === "image/png") {
        fileType = "png";
      } else if (file.type === "image/gif") {
        fileType = "gif";
      } else if (file.type === "image/jpg") {
        fileType = "jpg";
      } else if (file.type === "image/jpeg") {
        fileType = "jpeg";
      } else {
        message.error("LOGO文件必须是png、jpg、gif格式的图片文件");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async () => {
        setLogoContent(reader.result);
      };
      return false;
    },


  };

  return (
    <>
      <Modal
        forceRender={true}
        title="增加医院"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText="保存"
        cancelText="取消"
      >
        {loading && <Spin />}
        {!loading && (
          <>
            <Form
              form={form}
              name="unitadd"
              layout="horizontal"
              labelCol={{ span: 14 }}
              wrapperCol={{ span: 10 }}
            >
              <Form.Item name="province" label="医院所在省、自治区、直辖市">
                <Select onChange={onProvinceChange} placeholder="请选择...">
                  {provinceOptions}
                </Select>
              </Form.Item>
              <Form.Item name="city" label="医院所在市、区">
                <Select onChange={onCityChange} placeholder="请选择...">
                  {cityOptions}
                </Select>
              </Form.Item>
              <Form.Item name="county" label="医院所在县、区">
                <Select onChange={onCountyChange} placeholder="请选择...">
                  {countyOptions}
                </Select>
              </Form.Item>

              <Form.Item
                name="name"
                label="医院名称"
                rules={[
                  {
                    required: true,
                    message: "医院名称不能为空",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item name="logoFileName" label="医院LOGO">
                <Space direction="vertical">
                  <Upload {...props}>
                    <Button ghost type="primary" shape="round">
                      选择医院LOGO文件
                    </Button>
                  </Upload>
                  <img src={logoContent} alt="logo" height={25} width={100} />
                </Space>
              </Form.Item>
              <Divider />

              <Form.Item
                name="reportTitle"
                label="报告标题"
                rules={[
                  {
                    required: true,
                    message: "不能为空",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item valuePropName="checked" name="reportHasCheckDoctor" label="报告包括检测医生">
                <Checkbox />
              </Form.Item>

              <Form.Item valuePropName="checked" name="reportPrintHospitalName" label="报告包括医院名称">
                <Checkbox />
              </Form.Item>

              <Form.Item valuePropName="checked" name="reportPrintHospitalLogo" label="报告包括医院LOGO">
                <Checkbox />
              </Form.Item>
            </Form>
          </>)}
      </Modal>
    </>
  );
};
